import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

/** Revoke ("revoke") or re-enable ("restore") a registered mobile device. */
export const useMobileDeviceAction = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, action }) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/mobileapp/device/${id}/${action}`
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["mobileDevices"] });
    },
  });
};
